export function socialFeedSlider(selector = '.farlo-ui-social-feed', options = {}) {
    function initSlider() {
        if (document.querySelector('.fts-mashup-post-wrap')) {
            document.querySelectorAll('.fts-mashup-post-wrap').forEach(post => {
                const media = post.querySelector('.fts-album-photos-wrap');
                const multipleMedia = post.querySelector('.fts-album-photos-wrap');
                const instagram = post.querySelector('.fts-mashup-image-and-video-wrap');

                const hasMedia = media && media.innerHTML.trim().length > 0;
                const hasMultipleMedia = multipleMedia && multipleMedia.innerHTML.trim().length > 0;
                const hasInstagram = instagram && instagram.innerHTML.trim().length > 0;

                if (!hasMedia && !hasMultipleMedia && !hasInstagram) {
                    post.style.display = 'none';
                }
            });
        }
        const sliderContainer = document.querySelector(selector);
        const slider = sliderContainer?.querySelector('.fts-mashup');
        if (!slider) return null;
        const defaultOptions = {
            cellAlign: 'center',
            contain: true,
            pageDots: false,
            wrapAround: true,
            autoPlay: true,
            prevNextButtons: false,
            adaptiveHeight: false,
            ...options
        };
        const mainSlider = new Flickity(slider, defaultOptions);

        const internalSliders = sliderContainer?.querySelectorAll('.fts-more-photos-2-or-3-photos');
        if (internalSliders && internalSliders.length > 0) {
            internalSliders.forEach(internalSlider => {
                const images = internalSlider.querySelectorAll('img');
                let imagesLoaded = 0;
                const totalImages = images.length;

                function initInternalSlider() {
                    // Add a delay to allow layout to settle before initializing Flickity
                    setTimeout(() => {
                        const defaultInternalOptions = {
                            cellAlign: 'left',
                            contain: true,
                            draggable: false,
                            pageDots: true,
                            wrapAround: false,
                            autoPlay: 5000,
                            prevNextButtons: false,
                            adaptiveHeight: false,
                            ...options
                        };
                        const flickityInstance = new Flickity(internalSlider, defaultInternalOptions);
                        flickityInstance.resize();
                        function handleResize() {
                            flickityInstance.resize();
                        }
                        window.addEventListener('orientationchange', handleResize);
                        window.addEventListener('resize', handleResize);
                    }, 300);
                }

                if (totalImages === 0) {
                    initInternalSlider();
                } else {
                    images.forEach(img => {
                        if (img.complete) {
                            imagesLoaded++;
                        } else {
                            img.addEventListener('load', () => {
                                imagesLoaded++;
                                if (imagesLoaded === totalImages) {
                                    initInternalSlider();
                                }
                            });
                            img.addEventListener('error', () => {
                                imagesLoaded++;
                                if (imagesLoaded === totalImages) {
                                    initInternalSlider();
                                }
                            });
                        }
                    });
                    if (imagesLoaded === totalImages) {
                        initInternalSlider();
                    }
                }
            });
        }
        return mainSlider;
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSlider);
    } else {
        initSlider();
    }
}
